<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>网关日志</span>
          <div style="float: right;">
            <el-button type="primary" @click="exportExcel">导出</el-button>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-select v-model="searchForm.level" clearable placeholder="日志级别" @change="changeStatus">
            <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker v-model="searchForm.dateRange" type="datetimerange" :picker-options="pickerOptions"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
            align="right">
          </el-date-picker>

          <el-select v-model="searchForm.moduleCode" filterable placeholder="网关名称" clearable>
            <el-option v-for="item in moduleList" :key="item.code" :label="item.name" :value="item.code">
            </el-option>

          </el-select>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%" :empty-text="emptyText"
          @selection-change="handleSelectionChange">
          <el-table-column label="时间" min-width="50px">
            <template slot-scope="scope">
              {{ dateformat(scope.row.timestamp) }}
            </template>
          </el-table-column>
          <el-table-column prop="level" label="日志级别">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.severity === 'INFO' ? 'success' : (scope.row.severity === 'WARN') ? 'warning':'danger' "
                disable-transitions>
                {{scope.row.severity}}</el-tag>

              <!-- <div style="">{{ scope.row.severity }}</div> -->
            </template>
          </el-table-column>
          <el-table-column prop="rest" label="内容" min-width="200px"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs"

  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近1小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          ]
        },

        empty: false, //控制数据为空展示空页面
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        searchForm: {
          level: "",
          moduleCode: "",
          dateRange: ['', '']
        },
        levelList: [
          //状态数组
          {
            value: 'INFO',
            label: "INFO"
          },
          {
            value: 'WARN',
            label: "WARN"
          },
          {
            value: 'ERROR',
            label: "ERROR"
          }
        ],

        tableData: [],
        multipleSelection: [],
        moduleList: [],
        emptyText: "请输入网关编号和时间查询"
      };
    },
    created() { },
    mounted() {
      var moduleCode = this.$route.query.moduleCode;
      if (moduleCode) {
        this.searchForm.moduleCode = moduleCode;
      }
      this.getModuleList();
      this.initTimeRange()
    },
    methods: {

      //初始化时间
      initTimeRange() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000);
        this.searchForm.dateRange = [start, end]

      },

      /**********************获取网关下拉列表数据**************************/
      getModuleList() {
        let para = {
          // commuType: sessionStorage.getItem('commuType'),
        };
        API.ModuleDropdownlist(para)
          .then(res => {
            if (res.code == 1) {
              this.moduleList = res.data
            } else {
              this.$message.error(res.msg);
            }
          })

      },


      dateformat(date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      },

      exportExcel() {
        if (this.searchForm.dateRange.length < 2 || !this.searchForm.dateRange[1]) {
          this.$message.error("请选择时间");
          return;
        }
        if (this.searchForm.moduleCode === '') {
          this.$message.error("请输入正确的网关编号");
          return;
        }
        let para = {
          startTime: dayjs(this.searchForm.dateRange[0]).unix() * 1000, //Unix 时间戳 (秒)
          endTime: dayjs(this.searchForm.dateRange[1]).unix() * 1000, //Unix 时间戳 (秒)
          moduleCode: this.searchForm.moduleCode,
          level: this.searchForm.level,
          access_token: this.$cookies.get('access_token') ? this.$cookies.get('access_token') : ''
        };
        window.open(API.exportMduModuleLogUrl(para))
      },

      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.severity === 'WARN') {
          return 'warning-row';
        } else if (row.severity === 'INFO') {
          return 'success-row';
        } else if (row.severity === 'ERROR') {
          return 'error-row';
        }
        return '';
      },

      //获取列表复用
      getpageList() {
        if (!this.searchForm.dateRange || this.searchForm.dateRange.length === 0) {
          this.$message.error("请选择时间");
          return;
        }

        if (!this.searchForm.moduleCode) {
          this.$message.error("请选择网关");
          return;
        }

        let para = {
          startTime: dayjs(this.searchForm.dateRange[0]).unix() * 1000, //Unix 时间戳 (秒)
          endTime: dayjs(this.searchForm.dateRange[1]).unix() * 1000, //Unix 时间戳 (秒)
          moduleCode: this.searchForm.moduleCode,
          level: this.searchForm.level,
          pIntGetCount: this.pageSize,
          startRow: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformMduModuleLog(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
              if (this.total === 0) {
                this.emptyText = "无数据"
              }
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //搜索功能
      searchBtn() {
        this.currentPage = 1
        this.getpageList();
      },
      //下拉搜索
      changeStatus() {
        this.currentPage = 1
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.searchForm = {
          level: "",
          moduleCode: "",
          dateRange: []
        }
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList();
      }
    },
  };

</script>
<style>
  .el-table .error-row {
    background: #fdf2f2;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>


// WEBPACK FOOTER //
// src/views/platform/moduleLog.vue